import { ActionTypes } from '../../constants/ActionTypes';
import { IContactListItem, IContactState } from '../../interfaces/Contact';

const INIT_STATE: IContactState = {
  contactList: [],
  selectedContact: [],
  receiversList: [],
  contactsList: [],
  loadingInstance: false,
  endOfList: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    //*******************CONTACTS************************
    case ActionTypes.GET_CONTACTS: {
      if (action.payload.page === 0) state.contactsList = [];

      return {
        ...state,
        params: action.payload,
        loadingInstance: true,
      };
    }

    case ActionTypes.FETCH_CONTACTS_SUCCESS:
      return {
        ...state,
        contactsList: [...state.contactsList, ...action.payload],
        loadingInstance: false,
        endOfList: action.payload.length < 20,
      };

    //****************************************
    case ActionTypes.GET_All_CONTACT_SUCCESS: {
      return {
        ...state,
        contactList: action.payload,
      };
    }

    case ActionTypes.UPDATE_CONTACT_SUCCESS:
      return {
        ...state,
        contactList: state.contactList.map((contact: IContactListItem) =>
          contact.id === action.payload.id ? action.payload : contact,
        ),
      };

    case ActionTypes.DELETE_CONTACT_SUCCESS:
      return {
        ...state,
        contactList: state.contactList.filter(
          (contact: IContactListItem) => contact.id !== action.payload.id,
        ),
      };

    case ActionTypes.ON_ADD_CONTACT_SUCCESS:
      return {
        ...state,
        contactList: action.payload.contact(state.contactList),
      };

    case ActionTypes.GET_RECEIVERS_LIST: {
      return {
        ...state,
        searchText: action.payload,
      };
    }

    // case ActionTypes.FETCH_RECEIVERS_LIST_SUCCESS: {

    //const messages = getLocaleMsg();
    //   let groupsName = {
    //     // 0: "بدون عنوان",
    //     0: messages["receiversPriority.firstList"],
    //     1: messages["receiversPriority.organizationPersonnel"],
    //     2: messages["receiversPriority.externalContacts"],
    //     3: messages["receiversPriority.SecretariatPort"],
    //     4: messages["receiversPriority.personalReceiversGroup"],
    //     5: messages["receiversPriority.department"],
    //     6: messages["receiversPriority.organization"],
    //     7: messages["receiversPriority.miscellaneous"],
    //     8: messages["receiversPriority.organizationGroup"],
    //     9: messages["receiversPriority.specialMessage"],
    //   };

    //   let totalList: ITotalSortedreceiversList[] = [];
    //   let sortedFavoriteReceiversList: IContactListItem[] = [];
    //   let sortedOrgPersonsReceiversList: IContactListItem[] = [];
    //   let sortedOrgOutPersonsReceiversList: IContactListItem[] = [];
    //   let sortedSecretariateReceiversList: IContactListItem[] = [];
    //   let sortedReceiversGroupReceiversList: IContactListItem[] = [];
    //   let sortedOrgUnitReceiversList: IContactListItem[] = [];
    //   let sortedOrganizationReceiversList: IContactListItem[] = [];
    //   let sortedMiscellaneousReceiversList: IContactListItem[] = [];
    //   let sortedOrgsGroupReceiversList: IContactListItem[] = [];
    //   let sortedSpecialReferReceiversList: IContactListItem[] = [];

    //   if (action.payload && action.payload.length) {
    //     action.payload.map((item: any) => {
    //       if (item.isFavorite) {
    //         sortedFavoriteReceiversList.push(item);
    //       } else {
    //         switch (item.personType as number) {
    //           // case 0: {
    //           //   sortedNoTitleReceiversList.push(item);
    //           //   break;
    //           // }
    //           case 1: {
    //             sortedOrgPersonsReceiversList.push(item);
    //             break;
    //           }
    //           case 2: {
    //             sortedOrgOutPersonsReceiversList.push(item);
    //             break;
    //           }
    //           case 3: {
    //             sortedSecretariateReceiversList.push(item);
    //             break;
    //           }
    //           case 4: {
    //             sortedReceiversGroupReceiversList.push(item);
    //             break;
    //           }
    //           case 5: {
    //             sortedOrgUnitReceiversList.push(item);
    //             break;
    //           }
    //           case 6: {
    //             sortedOrganizationReceiversList.push(item);
    //             break;
    //           }
    //           case 7: {
    //             sortedMiscellaneousReceiversList.push(item);
    //             break;
    //           }
    //           case 8: {
    //             sortedOrgsGroupReceiversList.push(item);
    //             break;
    //           }
    //           case 9: {
    //             sortedSpecialReferReceiversList.push(item);
    //             break;
    //           }
    //           default:
    //             return null;
    //         }
    //       }
    //     });

    //     totalList.push({
    //       groupName: groupsName[0],
    //       totalReceiversList: sortedFavoriteReceiversList,
    //     });
    //     totalList.push({
    //       groupName: groupsName[1],
    //       totalReceiversList: sortedOrgPersonsReceiversList,
    //     });
    //     totalList.push({
    //       groupName: groupsName[2],
    //       totalReceiversList: sortedOrgOutPersonsReceiversList,
    //     });
    //     totalList.push({
    //       groupName: groupsName[3],
    //       totalReceiversList: sortedSecretariateReceiversList,
    //     });
    //     totalList.push({
    //       groupName: groupsName[4],
    //       totalReceiversList: sortedReceiversGroupReceiversList,
    //     });
    //     totalList.push({
    //       groupName: groupsName[5],
    //       totalReceiversList: sortedOrgUnitReceiversList,
    //     });
    //     totalList.push({
    //       groupName: groupsName[6],
    //       totalReceiversList: sortedOrganizationReceiversList,
    //     });
    //     totalList.push({
    //       groupName: groupsName[7],
    //       totalReceiversList: sortedMiscellaneousReceiversList,
    //     });
    //     totalList.push({
    //       groupName: groupsName[8],
    //       totalReceiversList: sortedOrgsGroupReceiversList,
    //     });
    //     totalList.push({
    //       groupName: groupsName[9],
    //       totalReceiversList: sortedSpecialReferReceiversList,
    //     });
    //   }

    //   return {
    //     ...state,
    //     receiversList: totalList,
    //   };
    // }

    default:
      return state;
  }
};
